import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { isDefinedString } from "et3-type-guards";
import getKhattabatStore from "..";
import getCorePopUpStore from "../../core/core-popup-store";
import { apiCallSendOneOOneMessage } from "../../../api/khattbat-api/api-call-send-one-o-one-message";
import { khattabaConversationParsing } from "../../../helpers/et3-conversation-parse";
import getKhattabatSharedMessagingStore from "./conversation-messaging-store";

class Khattabat101MessagingStore {
  conversationID = observable.box<string>("");
  receiverID = observable.box<number>(0);
  receiverUUID = observable.box<string>("");
  receiverName = observable.box<string>("");
  senderID = observable.box<number>(0);
  senderUUID = observable.box<string>("");
  senderName = observable.box<string>("");

  sendMessage = async () => {
    const conversationID = this.conversationID.get();
    const sharedStore = getKhattabatSharedMessagingStore(conversationID);
    const conversationType = sharedStore.conversationType.get();
    const messageText = khattabaConversationParsing(
      sharedStore.messageField.get()
    );
    const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
    const receiverUUID = this.receiverUUID.get();
    const receiverID = this.receiverID.get();

    if (
      sharedStore.isSending.get() ||
      !isDefinedString(alkhattabaUUID) ||
      !isDefinedString(receiverUUID) ||
      !isDefinedString(messageText)
    ) {
      return;
    }
    runInAction(() => {
      sharedStore.isSending.set(true);
    });
    const { status, code } = await apiCallSendOneOOneMessage({
      alkhattabaText: messageText,
      userID: receiverID,
      conversationType
    });
    runInAction(() => {
      sharedStore.isSending.set(false);
    });
    if (status === "OK") {
      sharedStore.appendSentMessage({
        message: messageText,
        messageType: "text"
      });
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getKhattabat101MessagingStore = memoize((conversationID: string) => {
  const store = new Khattabat101MessagingStore();
  store.conversationID.set(conversationID);
  return store;
});
export default getKhattabat101MessagingStore;
